import { IconButton } from "@mui/joy";
import { ChatCircle } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export function ProfileButtonMessage({ id = 0, disabled = false, itsme = false }) {
    const navigate = useNavigate();

    return (
        <IconButton
            onClick={() => navigate(`/chat/${id}`)}
            variant="soft"
            color="primary"
            sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                px: 2,
                py: 1,
                width: '56px',
                borderRadius: "999px",
                color: theme.palette.mode === 'dark'
                    ? theme.palette.primary[100]
                    : null,
                fontSize: '12px',
                '& svg': {
                    width: '24px',
                    height: '24px',
                }
            })}
            disabled={disabled}
        >
            <ChatCircle size={24} />
        </IconButton>
    )
}
